import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import autobind from 'autobind-decorator';
import {deleteTemplateCategory, deselectTemplateCategory, saveTemplateCategory, updateTemplateCategory} from 'template/actions';
import Dialog from 'apa/containers/Dialog';

@connect(
    state => ({
        selectedTemplateCategory: state.template.selectedTemplateCategory
    }),
    dispatch => {
        return {
            updateManualCategory: (category) => dispatch(updateTemplateCategory(category)),
            saveManualCategory: (category) => dispatch(saveTemplateCategory(category)),
            deleteManualCategory: (category) => dispatch(deleteTemplateCategory(category)),
            deselectManualCategory: () => dispatch(deselectTemplateCategory()),
        };
    })
export default class TemplateCategoryEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDeleteOpen: false
        };
    }

    @autobind
    toggleDelete() {
        this.setState({isDeleteOpen: !this.state.isDeleteOpen});
    }

    @autobind
    confirmDelete() {
        this.props.deleteManualCategory(this.props.selectedTemplateCategory);
        this.toggleDelete();
    }

    render() {
        const {
            selectedTemplateCategory
        } = this.props
        if(selectedTemplateCategory) {
            return (
                <Fragment>
                    <InputGroup>
                        <InputGroupAddon addonType='prepend'>
                            <Button color='primary' onClick={this.props.deselectManualCategory}>
                                <i className='fa fa-times'> </i>
                            </Button>
                        </InputGroupAddon>
                        <Input type='text' value={selectedTemplateCategory.name}
                               onChange={(e) => this.props.updateManualCategory({...selectedTemplateCategory, name: e.target.value})}
                               onBlur={(e) => this.props.saveManualCategory({...selectedTemplateCategory, name: e.target.value})}/>
                        <InputGroupAddon addonType='append'>
                            <Button color='danger' onClick={this.toggleDelete}>
                                <i className='fa fa-trash'> </i>
                            </Button>
                            <Dialog toggle={this.toggleDelete} confirm={this.confirmDelete} isOpen={this.state.isDeleteOpen}>
                                Sind Sie sicher?
                            </Dialog>
                        </InputGroupAddon>
                    </InputGroup>
                    <br/>
                </Fragment>
            );
        }
        return null;
    }
}
